module.exports = __webpack_public_path__ + "img/taxt.957171fa.png";